import React from 'react';
import './leftmenu.scss';
// import Parser from 'html-react-parser';
import { umoksType } from '../../../types/types.js';
// import { SideNav, Chevron, Icon } from 'react-side-nav';
import { Link } from 'react-router-dom';
// const NavLink = props => (<Link to={props.to} {...props}><i className={`fa ${props.icon}`} />{props.label}</Link>);

class LeftMenu extends React.Component {
  constructor(props) {
    super(props);
  };
  getMenu = () => {
    const { leftMenu } = this.props;

    if (leftMenu.length > 0) {
      return leftMenu.map((item, i, arr) => {
        const getLink = () => {
          return item.items.map((item, i, arr) => {
            return (
              <li key ={'menulink-' + i}><Link to={item.link}>{item.label}</Link></li>
            );
          });
        };

        return (
          <div>
            <h5>{item.label}</h5>
            <ul>
              {getLink()}
            </ul>
          </div>
        );
      });
    }
  };

  render() {
    return (
      <article className='leftmenu-wrap'>
        {this.getMenu()}
      </article>
    );
  };
};

LeftMenu.propTypes = {
  buisnessList:umoksType.isRequired
};

export default  LeftMenu;



// WEBPACK FOOTER //
// ./src/client/components/categorywrap/leftmenu/leftmenu.jsx